import React from "react";

const SelectField = ({
  id,
  label,
  options,
  value,
  onChange,
  disabled = false,
  invalid = false,
  errorMessage = "This field is required.",
}) => {
  return (
    <div className="flex items-center gap-4 w-full mb-4 ">
      <label
        htmlFor={id}
        className="text-base font-medium text-black whitespace-nowrap"
      >
        {label}
      </label>
      <div className="flex-1">
        <select
          id={id}
          name={id}
          disabled={disabled}
          value={value}
          onChange={onChange}
          className={`text-black appearance-none w-full px-0 py-2 border-0 border-b-2  ${
            invalid ? "border-b-red-500" : "border-b-gray-300" 
          } ${disabled ? "!text-black !opacity-100" : ""} focus:outline-none focus:ring-0 focus:border-b-indigo-500 bg-slate-50 font-medium`}
        >
          <option value="" disabled>
            {`Select`}
          </option>
          {options.map(({ value, label }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </select>
        {invalid && !value && (
          <p className="text-sm text-red-500 mt-1">{errorMessage}</p>
        )}
      </div>
    </div>
  );
};

export default SelectField;
